var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6422 2.23444L12.5611 0.927778C12.3511 0.663333 12.0322 0.5 11.6667 0.5H2.33333C1.96778 0.5 1.64889 0.663333 1.43111 0.927778L0.357778 2.23444C0.132222 2.49889 0 2.84889 0 3.22222V12.9444C0 13.8 0.7 14.5 1.55556 14.5H12.4444C13.3 14.5 14 13.8 14 12.9444V3.22222C14 2.84889 13.8678 2.49889 13.6422 2.23444ZM2.52 2.05556H11.48L12.11 2.81H1.89778L2.52 2.05556ZM1.55556 12.9444V4.38889H12.4444V12.9444H1.55556ZM8.12778 5.94444H5.87222V8.27778H3.88889L7 11.3889L10.1111 8.27778H8.12778V5.94444Z",
    fill: "#8A939A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.f559cb713faac150fec4c6e219910f6b.svg";
export { ForwardRef as ReactComponent };